import InputField from "../../../assets/components/InputField";
import PrimaryButton from "../../../assets/components/PrimaryButton";
import SecondaryButton from "../../../assets/components/SecondaryButton";

const FormOne = ({ formData, setFormData, handleBack }) => {
    const isPasswordMatch = formData.user.password === formData.user.confirm_password;

    return (
        <div className="w-full max-w-[720px]">
            <div className="grid grid-cols-2 gap-x-6 max-sm:grid-cols-1">
                <InputField
                    label="First Name"
                    required
                    type="text"
                    name="first_name"
                    placeholder="Enter your first name"
                    value={formData.user.first_name}
                    onChange={(e) => {
                        setFormData((prev) => ({
                            ...prev,
                            user: {
                                ...prev.user,
                                first_name: e.target.value,
                            },
                        }));
                    }}
                />

                <InputField
                    label="Last Name"
                    required
                    type="text"
                    name="last_name"
                    placeholder="Enter your last name"
                    value={formData.user.last_name}
                    onChange={(e) => {
                        setFormData((prev) => ({
                            ...prev,
                            user: {
                                ...prev.user,
                                last_name: e.target.value,
                            },
                        }));
                    }}
                />

                <InputField
                    label="Email"
                    required
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                    value={formData.user.email}
                    onChange={(e) => {
                        setFormData((prev) => ({
                            ...prev,
                            user: {
                                ...prev.user,
                                email: e.target.value,
                            },
                        }));
                    }}
                />

                <InputField
                    label="Phone Number"
                    required
                    type="number"
                    name="phone_number"
                    placeholder="Enter your phone number"
                    minLength={10}
                    pattern="^[0-9]+$"
                    title="must be a valid phone number"
                    value={formData.user.phone_number}
                    onChange={(e) => {
                        setFormData((prev) => ({
                            ...prev,
                            user: {
                                ...prev.user,
                                phone_number: e.target.value,
                            },
                        }));
                    }}
                />
            </div>

            <InputField
                label="Password"
                required
                type="password"
                name="password"
                placeholder="Enter your password"
                value={formData.user.password}
                onChange={(e) => {
                    setFormData((prev) => ({
                        ...prev,
                        user: {
                            ...prev.user,
                            password: e.target.value,
                        },
                    }));
                }}
            />

            <InputField
                label="Retype Password"
                required
                type="password"
                name="confirm_password"
                placeholder="Retype your password"
                value={formData.user.confirm_password}
                onChange={(e) => {
                    setFormData((prev) => ({
                        ...prev,
                        user: {
                            ...prev.user,
                            confirm_password: e.target.value,
                        },
                    }));
                }}
            />

            <div className="flex gap-6 mt-6 max-sm:flex-col-reverse">
                <SecondaryButton onClick={handleBack} className="flex-1 max-sm:w-full">
                    &lt; Back to Login
                </SecondaryButton>
                <PrimaryButton type="submit" disabled={!isPasswordMatch} className="flex-1 max-sm:w-full">
                    Next
                </PrimaryButton>
            </div>
        </div>
    );
};

export default FormOne;
